import type { operations } from "@/api/schema";

/**
 * Filter shapes mirror the BE query parameters 1:1 so each filter-set caches
 * independently (server-side filtering — BE B20). Derived from the generated
 * `operations` so they never drift from the contract.
 */
export type CampaignFilters = NonNullable<operations["listCampaigns"]["parameters"]["query"]>;
export type PromotionFilters = NonNullable<operations["listPromotions"]["parameters"]["query"]>;
export type ReportFilters = NonNullable<operations["getPromotionReport"]["parameters"]["query"]>;
export type RedemptionFilters = NonNullable<
  operations["listPromotionRedemptions"]["parameters"]["query"]
>;

export const promotionKeys = {
  all: ["promotion"] as const,
  campaigns: (f?: CampaignFilters) => [...promotionKeys.all, "campaigns", f] as const,
  campaign: (id: string) => [...promotionKeys.all, "campaign", id] as const,
  promotions: (f?: PromotionFilters) => [...promotionKeys.all, "promotions", f] as const,
  promotion: (id: string) => [...promotionKeys.all, "promotion", id] as const,
  precheck: (id: string) => [...promotionKeys.all, "precheck", id] as const,
  report: (f?: ReportFilters) => [...promotionKeys.all, "report", f] as const,
  redemptions: (f?: RedemptionFilters) => [...promotionKeys.all, "redemptions", f] as const,
  skuSearch: (term: string) => [...promotionKeys.all, "sku-search", term] as const,
  // Caller must sort + de-duplicate `codes` first (see useResolveSkuNames) so
  // the cache key is stable across equivalent sets.
  skuResolve: (codes: string[]) => [...promotionKeys.all, "sku-resolve", codes] as const,
  performance: (id: string) => [...promotionKeys.all, "performance", id] as const,
};
